const JSONToFormattedText = (json) => {
  const parseObject = (obj, indentLevel = 0) => {
    let formattedText = [];
    const indent = '&nbsp;'.repeat(indentLevel * 2); // Use HTML non-breaking space for indentation

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
          formattedText.push(`${indent}<strong>${key.toUpperCase()}:</strong>`); // Header in bold
          formattedText = formattedText.concat(parseObject(value, indentLevel + 1));
        } else if (Array.isArray(value)) {
          formattedText.push(`${indent}<strong>${key.toUpperCase()}:</strong>`); // Header in bold
          if (typeof value[0] === 'object') {
            value.forEach((item, index) => {
              formattedText.push(`${indent}&nbsp;&nbsp;- <strong>${key.toUpperCase()} ${index + 1}:</strong>`);
              formattedText = formattedText.concat(parseObject(item, indentLevel + 2));
            });
          } else {
            value.forEach((item) => {
              formattedText.push(`${indent}&nbsp;&nbsp;- ${item}`);
            });
          }
        } else {
          formattedText.push(`${indent}<strong>${key}:</strong> ${value}`); // Bold key
        }
      }
    }
    return formattedText;
  };

  const formattedText = parseObject(json);
  return formattedText.join('<br>');
};

export default JSONToFormattedText;
